<div class="header-bar">
  <h1>Organisation Custom Settings</h1>
</div>
<div class="content-container">
  <div class="flex-wrap flex filterPanel">
    <div class="flex-shrink-1">
      <div style="white-space: nowrap; margin-right: 70px; padding: 10px 0">
        Setting:
        <p-dropdown
          [(ngModel)]="setting"
          [options]="settingList"
          (onChange)="settingSelected($event)"
          [style]="{ 'min-width': '200px' }"
        ></p-dropdown>
      </div>
    </div>
    <div class="flex-grow-1" style="white-space: nowrap">
      <div style="display: inline-block; padding: 10px 0">
        Organisation:
        <p-autoComplete
          [suggestions]="organisationResult"
          [style]="{ 'min-width': '190px' }"
          (onSelect)="orgSelected($event)"
          (onKeyUp)="orgSelected($event)"
          (completeMethod)="filterOrgs($event)"
        ></p-autoComplete>
      </div>
    </div>
    <div class="flex-shrink-1" style="padding: 5px 0">
      <button
        *ngIf="canCreate"
        pButton
        [label]="canCreateDefault ? 'Create Default' : 'Create'"
        (click)="create(canCreateDefault ? null : organisationId)"
      ></button>
    </div>
  </div>

  <div class="" *ngIf="organisationId || setting">
    <div class="">
      <p-table selectionMode="single" [value]="orgSettingsList" [responsive]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 50px"></th>
            <th pSortableColumn="organisationName">Organisation</th>
            <th pSortableColumn="settingName">Setting</th>
            <th pSortableColumn="intValue">Integer</th>
            <th pSortableColumn="charValue">String</th>
            <th pSortableColumn="dateTimeValue">Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr (click)="edit(data)" [pSelectableRow]="data">
            <td style="width: 50px; text-align: center"><i class="fa fa-edit"></i></td>
            <td>
              {{ data?.organisationId }}
              {{ data?.organisationId == null ? 'SYSTEM DEFAULT' : data.organisationName }}
            </td>
            <td>{{ settingLookup[data?.setting] }}</td>
            <td>{{ data?.intValue }}</td>
            <td>{{ data?.charValue }}</td>
            <td>{{ data?.dateTimeValue | date : 'yyyy-MM-dd HH:mm:ss' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <p-dialog
    #editSettingDialog
    header="Organisation Setting {{ settingName }}"
    [(visible)]="showEditDialog"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '650px' }"
  >
    <form [formGroup]="formGroup">
      <input type="hidden" name="organisationSettingId" formControlName="id" />
      <input type="hidden" name="organisationId" formControlName="organisationId" />
      <input type="hidden" name="setting" formControlName="setting" />

      <table class="edit-table">
        <tbody>
          <tr>
            <td>Organisation:</td>
            <td>{{ formOrganisationId == null ? 'DEFAULT VALUE' : formOrganisationName }}</td>
          </tr>
          <tr>
            <td>String Value:</td>
            <td><input pInputText formControlName="charValue" /></td>
          </tr>
          <tr>
            <td>Number Value:</td>
            <td><input pInputText formControlName="intValue" type="number" /></td>
          </tr>
          <tr>
            <td>DateTime Value:</td>
            <td>
              <input pInputText formControlName="dateTimeValue" placeholder="YYYY-MM-DD HH:MM:SS" />
            </td>
          </tr>
        </tbody>
      </table>
    </form>

    <div class="ui-grid-row" style="float: right">
      <button
        *ngIf="f.id != null"
        type="button"
        class="red-btn mr-2"
        pButton
        (click)="deleteCustomSetting()"
        label="Delete"
      ></button>
      <button type="button" pButton label="Cancel" (click)="showEditDialog = false"></button>
      <button
        type="button"
        class="green-btn"
        pButton
        (click)="saveCustomSetting()"
        label="Save"
      ></button>
    </div>
  </p-dialog>
</div>
